<template>
    <div class="float-left mr-1">
        <span class="ml-2 icon-button" @click.stop="abrirModal()">
            <i class="fa fa-info-circle fa-lg mr-2 text-primary" title="Detalhar"></i>
            <strong>Existe atualização cadastral pendente de aprovação</strong>
        </span>
        <b-modal v-model="mostrarModal" @show="obterDadosCadastrais()" size="lg">
            <div slot="modal-title">Atualização cadastral pendente de aprovação</div>
            <b-row>
                <b-col sm="12">
                    <dados-a-serem-atualizados :dadosCadastrais="dadosCadastrais"></dados-a-serem-atualizados>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DadosCadastraisServicos from './DadosCadastraisServicos'
import DadosASeremAtualizados from './DadosASeremAtualizados'

export default {
	components: {
		DadosASeremAtualizados
	},

	props: {
		dadosCadastraisId: {
			type: String,
			default: () => ''
		}
	},

	data() {
		return {
			mostrarModal: false,
			dadosCadastrais: {}
		}
	},

	methods: {
		abrirModal() {
			this.mostrarModal = true
		},

		fecharModal() {
			this.mostrarModal = false
		},

		obterDadosCadastrais() {
			this.$store.dispatch('addRequest')
			DadosCadastraisServicos.obterPorId(this.dadosCadastraisId).then(
				response => {
					if (response) {
						if (response.success) {
							this.dadosCadastrais = response.data
							this.normalizarDados()
						}
					}
					this.$store.dispatch('removeRequest')
				}
			)
		},

		normalizarDados() {
			this.dadosCadastrais.dataCadastro = this.$maskDateTime(
				this.dadosCadastrais.dataCadastro
			)
			this.dadosCadastrais.telefone = this.$maskTelefone(
				this.dadosCadastrais.telefone
			)
			this.dadosCadastrais.cep = this.$maskCep(this.dadosCadastrais.cep)
		}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
